import * as React from "react";
import { Switcher, SwitcherProps } from "@emisgroup/ui-layouts";

/**
 * Responsible for rendering the badge component
 * @returns badge element
 */
export const UISwitcher: React.FC<SwitcherProps> = (props: SwitcherProps) => {

  return (
    <Switcher
      {...props}
    >
    </Switcher>
  );
};
